/* Move the existing ingredient CTA below its content on desktop; preserve its
   original node, purchase behaviour and exact mobile position. */
(() => {
  if (window.koppaProductDesktopRefinements) return;
  window.koppaProductDesktopRefinements = true;
  const desktop = window.matchMedia('(min-width: 1024px)');
  const placements = new Map();

  function reconcile() {
    for (const [section, item] of placements) {
      if (!item.marker.isConnected || !item.node.isConnected) {
        item.footer.remove();
        placements.delete(section);
      }
    }
    if (!desktop.matches) {
      for (const { node, marker, footer } of placements.values()) {
        marker.replaceWith(node);
        footer.remove();
      }
      placements.clear();
      return;
    }
    document.querySelectorAll('#MainContent .pp #product-formula').forEach(section => {
      if (section.closest('[data-koppa-approved-cream]') || placements.has(section)) return;
      const container = section.querySelector('.koppa-container');
      if (!container) return;
      const host = Array.from(container.children).find(element => element.classList.contains('md:block'));
      const action = host?.querySelector('[data-koppa-section-action]');
      if (!action) return;
      const node = action.closest('form') || action;
      const marker = document.createComment('Desktop ingredient CTA original position');
      const footer = document.createElement('div');
      footer.className = 'koppa-section-action-slot';
      footer.dataset.koppaDesktopFormulaFooter = '';
      node.before(marker);
      host.append(footer);
      footer.append(node);
      placements.set(section, { node, marker, footer });
    });
  }

  desktop.addEventListener('change', reconcile);
  document.addEventListener('shopify:section:load', reconcile);
  window.addEventListener('load', reconcile, { once: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile, { once: true });
  } else {
    reconcile();
  }
})();

/* The serum diagram has legacy inline-important styles. Override only those
   desktop declarations, restoring their exact values at the mobile breakpoint. */
(() => {
  const desktop = window.matchMedia('(min-width: 1024px)');
  const originals = new Map();
  const values = { background:'var(--koppa-product-dark-accent)', padding:'24px', 'align-self':'stretch' };
  function reconcileScienceCards() {
    if (!desktop.matches) {
      for (const [element, properties] of originals) {
        for (const [name, original] of Object.entries(properties)) {
          if (original.value) element.style.setProperty(name, original.value, original.priority);
          else element.style.removeProperty(name);
        }
      }
      originals.clear();
      return;
    }
    for (const element of document.querySelectorAll('#MainContent .pp[data-ploy-product-handle="ghk-cu-serum"] #product-science .product-molecule__inner > :is(article,koppa-card):last-child')) {
      if (!originals.has(element)) {
        originals.set(element, Object.fromEntries(Object.keys(values).map(name => [name, {
          value:element.style.getPropertyValue(name), priority:element.style.getPropertyPriority(name)
        }])));
      }
      for (const [name,value] of Object.entries(values)) element.style.setProperty(name,value,'important');
    }
  }
  desktop.addEventListener('change',reconcileScienceCards);
  document.addEventListener('shopify:section:load',reconcileScienceCards);
  window.addEventListener('load',reconcileScienceCards,{once:true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',reconcileScienceCards,{once:true});
  else reconcileScienceCards();
})();

(() => {
  const desktop = window.matchMedia('(min-width: 1024px)');
  const placements = new Map();
  function reconcileHeroReviews() {
    for (const [host, marker] of placements) {
      if (!host.isConnected) { marker.remove(); placements.delete(host); }
    }
    if (!desktop.matches) {
      for (const [host, marker] of placements) {
        if (marker.isConnected) marker.replaceWith(host);
      }
      placements.clear();
      return;
    }
    document.querySelectorAll('.pp:is([data-ploy-product-handle="ghk-cu-serum"],[data-ploy-product-handle="ghk-cu-balm-stick"]) #product-purchase').forEach(hero => {
      const review = hero.querySelector('.product-hero__customer-quote');
      const host = review?.closest('.ploy-source-control');
      const purchase = hero.querySelector('.kdh-purchase');
      if (!host || !purchase || placements.has(host)) return;
      const marker = document.createComment('Hero review mobile position');
      host.before(marker);
      purchase.before(host);
      placements.set(host, marker);
    });
  }
  const observer = new MutationObserver(reconcileHeroReviews);
  function init() {
    document.querySelectorAll('.pp:is([data-ploy-product-handle="ghk-cu-serum"],[data-ploy-product-handle="ghk-cu-balm-stick"]) #product-purchase').forEach(hero => observer.observe(hero, { childList: true, subtree: true }));
    reconcileHeroReviews();
  }
  desktop.addEventListener('change', reconcileHeroReviews);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
